/* eslint-disable max-lines */
import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Précédent',
      changePassword: 'Changer de mot de passe',
      copiedVaultId: 'Copié !',
      copyVaultID: "Copier l'ID Vault",
      create: 'Créer',
      next: 'Suivant',
      notSure: 'Je ne suis pas sûr',
      signUp: 'Inscrivez-vous',
      submit: 'Soumettre',
      updatePassword: 'Mettre à jour le mot de passe',
    },
    Errors: {
      createReportFailed: 'La création du signalement a échoué.',
    },
    ReportStatus: {
      CLOSED: 'Clôturé',
      INVESTIGATING: "À l'étude",
      NEW: 'Soumis',
      READ: 'Lu',
    },
    general: {
      navbar: {
        caseSettings: 'Paramètres de cas',
        changePassword: 'Changer le mot de passe',
        logOut: 'Se déconnecter',
        notifications: 'Notifications',
        notificationsDrawer: {
          appFileScanFailed: 'Un fichier a échoué le contrôle de sécurité',
          appReportMatch: 'Votre enregistrement GoTogether a été associé',
          appReportReassigned:
            'Un nouveau responsable de dossier a été attribué',
          case: 'Cas',
          caseAssigned: 'Cas assigné à vous',
          caseImporterJobCompleted: {
            PartialSuccess:
              "Votre importation de dossier s'est terminée avec des erreurs",
            failure: 'Votre importation de cas a échoué',
            success: 'Votre importation de cas a été réalisée avec succès',
          },
          caseLinked: 'Cas lié',
          caseTeamInvite: 'Ajouté au dossier',
          caseUnlinked: 'Cas non lié',
          dataSanitisation: 'Détails du rapport mis à jour',
          emptyDescription: 'Revenez plus tard pour de nouvelles notifications',
          emptyTitle: 'Vous êtes à jour',
          importId: "ID d'importation:",
          learnMore: 'En savoir plus',
          markAllAsRead: 'Marquer tout comme lu',
          newMessage: 'Nouveau message',
          newReport: 'Nouveau rapport reçu',
          permissionRemoved: "Retiré de l'affaire",
          postSSubmissionFile: 'Fichier(s) de preuve ajouté(s)',
          report: 'Rapport',
          reportAssigned: 'Rapport qui vous a été attribué',
          reportStatusChange: 'Le statut du rapport a changé',
          reporterAnonymised: 'Vos détails ont été rendus anonymes',
          reporterReportSubmitted: {
            subtitle:
              'Nous recommandons de sauvegarder une copie de votre rapport',
            title: 'Rapport soumis',
          },
          mitigationPlanReminder: 'Approbation du plan de mitigation requise',
          staleCase: 'Cas non traité',
        },
        privacyStatement: 'Déclaration de confidentialité',
        reporter: {
          myReports: 'Mes rapports',
        },
        settings: 'Paramètres',
        technicalSupport: 'Assistance technique',
        title: 'Compte',
      },
      time: {
        day: 'Jour',
        days: 'Jours',
        hour: 'Heure',
        hours: 'Heures',
        minute: 'Minute',
        minutes: 'Minutes',
        second: 'Seconde',
        seconds: 'Secondes',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonyme',
        autoTranslate: 'La traduction automatique est désactivée par défaut.',
        backToMessages: 'Retourner aux messages',
        caseSettings: 'Paramètres du dossier.',
        changeInProfile:
          'Si vous souhaitez modifier ce paramètre, vous pouvez le faire dans votre profil',
        deletedByMessage: 'Supprimé par {{author}}',
        deletedMessageLabel: 'Ce message a été supprimé',
        description:
          "Lorsque la traduction automatique est activée, tous les messages de rapport seront\n          automatiquement traduits à l'aide de l'IA en fonction de la langue par défaut\n          sélectionnée sur votre navigateur.",
        descriptionSecondHalf:
          'La version originale de tous les messages est toujours préservée et peut être trouvée dans le chat.',
        messagePlaceholder: 'Commencez à taper...',
        messageSettings: 'Paramètres de message.',
        originalMessages: 'Original',
        showMoreBanner: 'En savoir plus sur les traductions automatiques',
        titlev2: 'Lisez tous les messages dans votre langue préférée.',
        translatedMessageLabel: 'Message Traduit',
        translatedMessages: 'Traduit',
        understood: 'Compris',
      },
      Country: {
        description: 'Dans quel pays êtes-vous basé ?',
        header: 'Dans quel pays êtes-vous basé ?',
        noOptions: 'Aucun pays trouvé',
        other: 'Autre',
        placeholder: 'Rechercher un pays...',
      },
      CreatePublicReport: {
        createReport: 'Faire un nouveau signalement',
        helpPage: "Allez sur notre page d'aide",
        loginToOpr: 'Connectez-vous pour suivre les rapports',
        or: 'ou',
        passwordPlaceholder: 'Saisir le mot de passe',
        phoneNumberLoginFailed:
          'La connexion a échoué, le numéro de téléphone / le code pin est incorrect',
        phoneNumberPlaceholder: 'Entrez votre numéro de téléphone',
        phoneNumberTooltip:
          'Entrez le numéro de téléphone que vous avez utilisé pour contacter VaultTalk',
        pinPlaceholder: 'Entrez le code PIN',
        reportIntroductionParagraph1:
          'Lorsque vous signalez un incident, on vous posera quelques questions pour vous aider à documenter votre expérience.',
        reportIntroductionParagraph2:
          "Avant de soumettre, vous avez l'option de rester anonyme pour protéger votre vie privée.",
        reportIntroductionParagraph3:
          "Après votre soumission, vous pouvez vous connecter à tout moment pour voir l'avancement de votre rapport et parler à un gestionnaire de cas.",
        reportIssue: 'Signaler un problème',
        usernameLoginFailed:
          "Échec de connexion, nom d'utilisateur/mot de passe incorrect",
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              "La relation avec l'entreprise est requise",
            reportedCategoryRequired: 'La catégorie signalée est requise',
          },
        },
        vaultId: 'ID de Vault',
        vaultIdPlaceholder: 'Entrez votre Email ou Vault ID',
        vaultIdTooltip:
          "Pour les rapports anonymes, l'ID Vault est alphanumérique. Si le rapport n'était pas anonyme, l'ID Vault est votre adresse e-mail.",
        vaultTalk: 'VaultTalk',
        yourPassword: 'Votre mot de passe',
        yourPhoneNumber: 'Votre numéro de téléphone',
        yourPin: 'Votre code PIN à 6 chiffres',
        yourVaultId: 'Votre ID Vault',
      },
      CustomHeader: {
        companyLogo: 'Logo de l’entreprise',
        openReporting: 'Ouvrir la fonction de signalement',
        userSettings: 'Paramètres utilisateur',
      },
      Date: {
        approximateDescription:
          "Vous souvenez-vous de la date approximative à laquelle l'événement s'est déroulé ?",
        approximatePlaceholder:
          'Exemple : il y a 6 mois / l’an dernier / en novembre dernier',
        cancel: 'annuler',
        clear: 'effacer',
        description:
          "Vous souvenez-vous de la date à laquelle l'événement s'est déroulé ?",
        header: "Quel jour cela s'est-il passé ?",
        ok: 'OK',
        placeholder: 'Exemple : 21 juin 2020',
      },
      Description: {
        whatHappened: "Que s'est-il passé ?",
        whatHappenedPlaceholder: 'Utilisez vos propres mots...',
        whatHappenedText: "Avec vos propres mots, décrivez ce qui s'est passé",
      },
      Details: {
        disclaimer:
          "Ces détails seront divulgués avec votre rapport. Si vous souhaitez rester anonyme, assurez-vous qu'ils ne contiennent pas d'informations d'identification.",
        emailPlaceholder: 'E-mail (facultatif)',
        fullNamePlaceholder: 'Nom complet (facultatif)',
        header: 'Coordonnées',
        nonAnonSubtitle:
          'Veuillez fournir soit votre nom, soit une adresse e-mail. Si vous souhaitez recevoir des notifications concernant ce rapport, ajoutez une adresse e-mail appropriée ci-dessous.',
        nonOptionalEmailPlaceholder: 'Email',
        nonOptionalFullNamePlaceholder: 'Nom complet',
        subtitle:
          'Si vous souhaitez recevoir des notifications au sujet de ce rapport, ajoutez une adresse e-mail appropriée ci-dessous.',
      },
      Emotion: {
        description:
          "Qu'avez-vous ressenti ? Quelles ont été les conséquences ?",
        header: 'Quelles ont été les conséquences ?',
        placeholder: 'Commencez la saisie...',
      },
      Evidence: {
        addedHeading: 'Ajouté',
        deletedMessage: 'a été supprimé',
        deletedStatus: 'Supprimé',
        failedToOpenFileMessage:
          "Échec de l'ouverture du fichier. Veuillez réessayer",
        fileStatuses: {
          infectedUpload: 'Signalé par le contrôle de sécurité',
          passedUpload: 'Passé le contrôle de sécurité',
          pendingUpload: 'Contrôle de sécurité en cours',
          readyForDownload: 'Prêt à être téléchargé',
        },
        mobileErrorMessage:
          'Fichiers signalés : Envoyez un message à votre gestionnaire de cas',
        nameHeading: 'Nom',
        statusHeading: 'Statut',
        tableTitle: 'Preuve',
        webErrorMessage:
          'Fichiers signalés : Si votre(vos) fichier(s) a(ont) été signalé(s), veuillez envoyer un message au gestionnaire de cas.',
      },
      FileUpload: {
        addFiles: 'Ajouter des fichiers',
        addMoreFiles: 'Ajoutez plus de fichiers',
        confirm: 'Confirmer',
        description:
          "L'ajout de fichiers comme preuves peut aider à soutenir l'efficacité de la résolution par votre gestionnaire de cas. Veuillez prendre en compte le contenu du fichier (y compris les métadonnées du fichier) si vous souhaitez rester anonyme, et respecter les droits des autres individus et les lois applicables.",
        dragDrop: 'Déposez les fichiers ici ou',
        errorMessage:
          "Le(s) fichier(s) n'a/n'ont pas réussi à cause d'une erreur réseau. Cliquez ci-dessous pour envoyer un message à votre gestionnaire de cas pour obtenir de l'aide.",
        fileLimit: 'Limite de taille pour chaque fichier : 100MB',
        fileUploadLimitText: 'Vous ne pouvez télécharger que 10 fichiers',
        header: 'Ajouter des preuves',
        helpArticle: "article d'aide",
        highlighted: 'parcourir les fichiers',
        information: 'Types de fichiers pris en charge',
        moreInformation:
          "Pour plus d'informations, veuillez consulter ceci <a>article d'aide</a>",
        postSubmissionErrorMessage:
          "Nous n'avons pas pu télécharger vos fichiers en raison d'une erreur système. Veuillez sélectionner 'confirmer' à nouveau.",
        tooltipAudio: 'Audio:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Documents:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Images:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Texte:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Vidéo:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Le fichier est trop volumineux',
          invalidFileType: 'Type de fichier non pris en charge : {{extension}}',
          systemError: 'Erreur système',
          tooManyFiles: 'Le nombre maximum de fichiers est {{maxFiles}}',
        },
        uploadFiles: 'Télécharger des fichiers',
      },
      Loading: {
        loading:
          'Veuillez patienter pendant que nous soumettons votre rapport à un gestionnaire de cas...',
        postSubmissionLoading:
          'Veuillez attendre pendant que nous soumettons votre(s) fichier(s)...',
      },
      Location: {
        description: "Où cela s'est-il passé ?",
        header: "Où cela s'est-il passé ?",
        placeholder: 'Exemple : au bureau',
      },
      MessageListBox: {
        messageCaseManager: 'Envoyer un message au responsable',
        report: 'Signaler {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Traduction désactivée',
        enableTranslationLabelEnabled: 'Traduction activée',
        enableTranslationsDescription:
          'Activez les traductions automatiques et lisez tous les messages de rapport dans votre langue préférée. La langue traduite est basée sur la langue sélectionnée sur votre appareil.',
        enableTranslationsHeader:
          'Activer les traductions automatiques pour les messages de rapport',
        enableTranslationsSubDescriptionv2:
          'Vous pouvez basculer entre la langue traduite et la langue originale dans chaque discussion.',
        updateTranslationFailed: 'La mise à jour de la traduction a échoué',
        updateTranslationSuccess:
          'Paramètre de traduction mis à jour avec succès',
      },
      Password: {
        changePasswordHeader: 'Changer de mot de passe',
        createNewPassword: 'Veuillez créer un nouveau mot de passe',
        createPasswordHeader: 'Votre mot de passe',
        currentPasswordPlaceholder: 'Saisir le mot de passe en cours',
        description:
          'Un mot de passe valide doit contenir au moins 9 caractères et inclure une majuscule et un chiffre',
        enterCurrentPassword: 'Veuillez saisir votre mot de passe en cours',
        forgottenPasswordInstructions:
          'Entrez votre identifiant Vault alphanumérique (pas votre adresse e-mail) et votre adresse e-mail pour réinitialiser votre mot de passe.',
        newDescription:
          'Créez un mot de passe fort pour sécuriser votre compte. Commencez à taper pour voir les directives ci-dessous.',
        passwordPlaceholder: 'Créer un mot de passe',
        passwordResetRequestedDescription:
          'Si votre ID Vault existe dans notre système, vous recevrez un email avec des instructions pour réinitialiser votre mot de passe.',
        passwordResetRequestedHeader:
          'Lien de réinitialisation du mot de passe demandé',
        reenterPlaceholder: 'Saisissez de nouveau le mot de passe',
        subtitle:
          'Créez un mot de passe pour soumettre ce signalement et y accéder plus tard',
        yourVaultId: 'Votre identifiant Vault',
        yourVaultIdPlaceholder:
          'Entrez votre ID de Vault (par exemple, {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Signalez-vous le comportement d’une ou plusieurs personnes ? Pouvez-vous les nommer ou les décrire ?',
        header: 'Personnes impliquées',
        placeholder:
          'Commencez la saisie et utilisez une virgule pour ajouter plusieurs noms ou descriptions',
      },
      PoweredByVault: 'Optimisé par {{company}}',
      PrivacyStatement: 'Déclaration de confidentialité du produit',
      PublicMessageList: {
        myMessages: 'Mes messages',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Preuve ajoutée au rapport existant',
        backToReportId: 'Retour au rapport ID : {{reportId}}',
        description:
          "Ajouter des fichiers en tant que preuves peut aider à soutenir l'efficacité de la résolution par votre gestionnaire de cas. Veuillez considérer le contenu du fichier (y compris les métadonnées du fichier) si vous souhaitez rester anonyme, et respecter les droits des autres individus et les lois applicables. Pour plus d'informations, veuillez consulter ceci <a>article d'aide</a>",
        header: 'Ajoutez des preuves supplémentaires au rapport',
        vaultTalkOpenCaseHeader: 'Ajoutez des preuves à votre rapport',
      },
      PublicReport: {
        anonymous: 'Anonyme',
        backToReports: 'Retourner aux signalements',
        skipped: 'Ignoré',
      },
      PublicReportCard: {
        addEvidence: 'Ajoutez des preuves supplémentaires',
        messageCaseManager: 'Envoyer un message au responsable',
        reportId: 'ID du signalement :',
        submitted: 'Soumis',
        vaultTalkClosedCaseCTA: 'Voir les preuves',
        vaultTalkOpenCaseCTA: 'Ajouter des preuves',
        viewAdditionalEvidence: 'Voir des preuves supplémentaires',
        viewReport: 'Voir le signalement',
      },
      PublicReportsList: {
        reportingSystem: 'Système de signalement',
      },
      Question: {
        placeholder: 'Commencez à taper...',
        question: 'Fournir des détails',
        questionText:
          'Veuillez partager avec nous votre préoccupation, mise à jour ou demande de renseignements.',
      },
      Relationship: {
        header: 'Votre relation avec l’organisation',
        tellUsAbout: 'Parlez-nous de votre relation avec l’organisation.',
      },
      ResponsiveNavMenu: {
        messages: 'Mes messages',
        reports: 'Mes rapports',
      },
      Site: {
        description: 'Sur quel site êtes-vous basé ?',
        header: 'Sur quel site êtes-vous basé ?',
        noOptions: 'Aucun site trouvé',
        other: 'Autre',
        placeholder: 'Rechercher un site...',
      },
      SpamPuzzle: {
        dialog: 'Pour continuer, résolvez cette énigme',
      },
      SubmissionTypes: {
        reportIssue: 'Sélectionnez une catégorie',
        whatType: 'Sélectionnez la catégorie qui décrit le mieux votre rapport',
      },
      SubmitSuccess: {
        category: '<bold>Catégorie :</bold> {{category}}',
        country: '<bold>Pays:</bold> {{country}}',
        dateSubmitted: '<bold>Date de soumission :</bold> {{date}}',
        recordYourVaultID:
          'Souvenez-vous de ces informations pour la connexion',
        successInformation: "Plus d'information",
        successMessage:
          'Votre rapport a été soumis et est prêt pour examen. Tout fichier joint nécessitant une attention sera signalé lors de la connexion. Connectez-vous ci-dessous pour voir les mises à jour du rapport et envoyer un message à votre gestionnaire de cas.',
        successSanitationMessage:
          'Sauvegardez une copie pour vos archives et gardez votre Vault-ID en sécurité — vous en aurez besoin pour accéder aux mises à jour et contacter votre gestionnaire de cas.',
        successSanitationTagline:
          'Votre rapport a été soumis et stocké en toute sécurité.',
        successThankYou: 'Merci pour votre rapport !',
        viewReport: 'Voir le rapport',
      },
      Time: {
        approximateDescription:
          "Vous souvenez-vous de l'heure approximative à laquelle l'événement s'est déroulé ?",
        approximatePlaceholder: 'Exemple : le matin, l’après-midi',
        description:
          "Vous souvenez-vous de l'heure à laquelle l'événement s'est déroulé ?",
        header: "À quelle heure cela s'est-il passé ?",
        invalidTime: 'L’heure doit être au format HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Changer de mot de passe',
        closeDialog: 'Fermer la boîte de dialogue',
        logout: 'Se déconnecter',
        messageSettings: 'Paramètres du message',
        userSettings: 'Paramètres utilisateur',
      },
      Witnesses: {
        description:
          "L'avez-vous raconté à quelqu'un ou y avait-il un témoin ?",
        header: 'Des témoins ?',
        placeholder: 'Commencez la saisie...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Envoyer un message',
        title: 'Gestionnaire de cas de messagerie',
        translationHeader: 'En savoir plus sur les traductions automatiques',
      },
      ReportCard: {
        addEvidence: 'Ajouter des preuves',
        submissionModeVia: 'via {{mode de soumission}}',
        viewEvidence: 'Voir les preuves',
      },
      ReportList: {
        yourReports: 'Vos rapports',
      },
      ReportingActivate: {
        buttonText: 'Continuer',
        description:
          'Si votre organisation vous a inscrit pour un compte, nous vous enverrons un email avec des instructions pour terminer la configuration.',
        emailInput: 'Email',
        header: 'Entrez votre email professionnel',
        successAccount:
          'Si votre organisation vous a enregistré pour un compte, nous vous enverrons un email avec des instructions pour terminer la configuration.',
        successEmail:
          "Si vous ne le voyez pas immédiatement, veuillez attendre quelques minutes et actualisez votre boîte de réception d'email.",
        successHeading: 'Merci',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Ajoutez des preuves à votre rapport',
        descriptionText:
          "L'ajout de fichiers comme preuves peut aider à soutenir l'efficacité de la résolution par votre gestionnaire de cas. Veuillez considérer le contenu du fichier (y compris les métadonnées du fichier) si vous souhaitez rester anonyme, et respecter les droits des autres individus et les lois applicables. Pour plus d'informations, veuillez consulter cet <a>article d'aide</a>",
        emptyMessage: 'Aucune preuve supplémentaire téléchargée',
      },
      ReportingChangePassword: {
        back: 'Retour',
        description:
          'Créez un mot de passe solide pour sécuriser votre compte. Commencez à taper pour voir les directives ci-dessous.',
        errorToast: 'Impossible de créer un mot de passe, jeton non valide.',
        header: 'Changer le mot de passe',
        incorrectCurrentPassword:
          'Le mot de passe actuel est incorrect. Veuillez le vérifier et réessayer.',
        invalidToken: 'Jeton invalide',
        passwordUpdated: 'Mot de passe mis à jour',
        passwordUpdatedDescription:
          "Votre mot de passe a été mis à jour avec succès. Merci d'avoir pris cette mesure pour garder vos données en sécurité !",
        passwordUsedBefore:
          "La réutilisation du mot de passe n'est pas autorisée",
        passwordUsedBeforeDescription:
          "Pour votre sécurité, vous ne pouvez pas réutiliser l'un de vos six derniers mots de passe. Veuillez choisir un nouveau mot de passe unique pour sécuriser votre compte et réessayez.",
        toastDescription:
          "Votre mot de passe a été mis à jour avec succès. Merci d'avoir pris cette mesure pour assurer la sécurité de vos données !",
        toastMessage: 'Mot de passe mis à jour',
        updatePasswordCTA: 'Mettre à jour le mot de passe',
      },
      ReportingConnect: {
        cancelButton: 'Annuler',
        connectButton: 'Connecter',
        disclaimer:
          'La connexion de votre compte Slack avec votre compte Vault garantit une connexion sécurisée et privée.<br /><br />En vous connectant, vous pouvez signaler un comportement inapproprié ou poser une question directement dans Slack. Vous aurez toujours la possibilité de signaler anonymement après vous être connecté. Votre vie privée et votre sécurité sont nos principales priorités.',
        heading:
          "Vault Platform demande l'autorisation d'accéder à votre compte Slack {{organisationName}}",
        listHeading: 'Que pourra faire Vault ?',
        permissionIdentity: {
          extraInfo:
            "Vault aura la capacité de voir l'identité de votre utilisateur Slack",
          heading: "Voir des informations sur l'identité d'un utilisateur",
        },
        permissionNotifications: {
          extraInfo:
            "Vault pourra vous envoyer des notifications sur votre compte Slack, concernant toute mise à jour d'un rapport soumis ou d'une question",
          heading: 'Vous envoyer des notifications',
        },
        permissionOverview: {
          extraInfo:
            "Vault affichera un aperçu de toutes les soumissions sur la page d'accueil",
          heading: 'Aperçu des soumissions',
        },
        permissionSubmitReport: {
          extraInfo:
            'Cela accordera à Vault la permission de soumettre un rapport ou de poser une question, directement à votre organisation, depuis Slack',
          heading: 'Soumettez un rapport ou une question en votre nom',
        },
        successfulConnectionDescription:
          'Votre compte Vault et votre compte Slack sont maintenant connectés. Vous pouvez maintenant fermer cet onglet et retourner à Slack.',
        successfulConnectionHeading: 'Connecté avec succès',
        unsuccessfulConnectionDescription:
          'Quelque chose a mal tourné. Veuillez fermer cet onglet et revenir à Slack pour réessayer.',
        unsuccessfulConnectionHeading: 'Échec de la connexion',
      },
      ReportingForgotPassword: {
        description:
          "Entrez l'adresse e-mail associée à votre compte, et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
        heading: 'Mot de passe oublié',
        invalidTokenError:
          'Impossible de créer un mot de passe, jeton non valide.',
        passwordReuseError:
          "La réutilisation de mot de passe n'est pas autorisée",
        passwordReuseErrorDescription:
          "Pour votre sécurité, vous ne pouvez pas réutiliser l'un de vos six derniers mots de passe. Veuillez choisir un nouveau mot de passe unique pour sécuriser votre compte et essayez à nouveau.",
        sendLink: 'Envoyer le lien de réinitialisation',
        sendLinkFailure: 'Quelque chose a mal tourné',
        sendLinkFailureDescription:
          "Revenez au <a>Reporter Hub</a> et réessayez. Si le problème persiste, contactez-nous à l'adresse <mailto>techsupport@vaultplatform.com</mailto>",
        sendLinkSuccess: 'Lien de réinitialisation du mot de passe envoyé',
        sendLinkSuccessDescription:
          'Nous avons envoyé un lien de réinitialisation de mot de passe à {{email}}',
        updatePasswordSuccess: 'Mot de passe mis à jour',
        updatePasswordSuccessDescription:
          "Votre mot de passe a été mis à jour avec succès. Merci d'avoir pris cette mesure pour garder vos données en sécurité !",
      },
      ReportingLogin: {
        accountFrozen: 'Le compte est gelé',
        accountLocked:
          "La connexion a été tentée trop de fois incorrectement. Le compte est verrouillé pour jusqu'à 1 heure. La réinitialisation du mot de passe n'est pas possible pendant cette période.",
        accountLockedPermanently:
          "Votre compte a été bloqué. Utilisez la réinitialisation du mot de passe pour retrouver l'accès ou contactez votre administrateur système pour plus d'aide.",
        createAccountCTA: 'Inscrivez-vous pour un compte',
        currentPassword: 'Mot de passe actuel',
        emailLabel: 'Votre Email',
        forgotPassword: 'Vous avez oublié votre mot de passe ?',
        loginButton: 'Connexion',
        newPasswordPlaceholder: 'Nouveau mot de passe',
        passwordFailMessage:
          "Revenez à l'application Vault dans Slack et essayez de nouveau. Si le problème persiste, contactez-nous à techsupport@vaultplatform.com",
        passwordFailTitle: "Quelque chose s'est mal passé",
        passwordLabel: 'Votre mot de passe',
        passwordPlaceholder: 'Entrez votre mot de passe',
        passwordResetRequired: 'Réinitialisation du mot de passe requise',
        passwordSuccessfullySetMessage:
          "Retournez à l'application Vault dans Slack et authentifiez-vous avec votre nouveau mot de passe pour continuer là où vous vous étiez arrêté.",
        passwordSuccessfullySetTitle: 'Mot de passe défini avec succès',
        reenterPlaceholder: 'Ressaisir le mot de passe',
        title: 'Reporter Hub',
        tooltip:
          'Si vous n\'avez jamais défini de mot de passe pour l\'application Vault, suivez ici pour commencer. Si vous avez oublié votre mot de passe, utilisez le lien "Mot de passe oublié" ci-dessous.',
        usernameLoginFailed:
          "Échec de la connexion, nom d'utilisateur ou mot de passe incorrect",
      },
      ReportingReset: {
        failureDescription:
          "Retournez à l'application Vault dans Slack et essayez à nouveau. Si le problème persiste, contactez-nous à <mailto>techsupport@vaultplatform.com</mailto>",
        failureHeading: 'Quelque chose a mal tourné',
        successDescription:
          "Retournez à l'application Vault dans Slack et authentifiez-vous avec votre nouveau mot de passe pour reprendre là où vous vous êtes arrêté.",
        successHeading: 'Mot de passe défini avec succès',
      },
      noReports: {
        description:
          'Tous les rapports soumis seront affichés ici. Apprenez-en plus sur les différentes façons dont vous pouvez soumettre un rapport.',
        descriptionHelpArticle: "cet article d'aide",
        errorDescription:
          'Nous avons du mal à charger vos rapports. Veuillez essayer de rafraîchir la page.',
        errorDescriptionSecondary:
          'Si cela ne fonctionne pas, veuillez nous contacter à',
        errorTitle: '⚠️ Oups, quelque chose a mal tourné',
        title: "Vous n'avez encore aucun rapport",
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Activez les traductions automatiques et lisez tous les messages de rapport dans votre langue préférée. La langue traduite est basée sur la langue sélectionnée sur votre appareil.',
          autoTranslationDescription2:
            'Vous pouvez basculer entre la langue traduite et la langue originale dans chaque discussion.',
          autoTranslationTitle:
            'Activer les traductions automatiques pour les messages de rapport',
          header: 'Paramètres de messages',
          subHeader: "Configurez l'affichage des messages",
        },
        notificationSettings: {
          emailDescription:
            'Recevez des notifications par email pour les mises à jour importantes de vos rapports',
          emailTitle: 'Notifications par Email',
          header: 'Paramètres de notification',
          subHeader: 'Configurez comment vous recevez les notifications',
        },
        title: 'Paramètres',
        updatedSettingsFailure: 'Échec de la mise à jour de vos paramètres',
        updatedSettingsSuccess: 'Vos paramètres ont été mis à jour avec succès',
      },
    },
    validators: {
      passwordLength: 'Le mot de passe doit contenir au moins 9 caractères',
      passwordLowercase:
        'Le mot de passe doit contenir au moins 1 lettre en minuscule',
      passwordMissMatch:
        'Les champs de mot de passe et de confirmation doivent correspondre.',
      passwordNumeric: 'Le mot de passe doit contenir au moins 1 chiffre',
      passwordUppercase:
        'Le mot de passe doit contenir au moins 1 lettre en majuscule',
    },
    validatorsNew: {
      passwordLength: 'Entre 10 et 30 caractères',
      passwordLowercase: 'Au moins une lettre minuscule',
      passwordMissMatch: 'Les mots de passe ne correspondent pas',
      passwordNumeric: 'Au moins un numéro',
      passwordSpecialCharacter: 'Au moins un caractère spécial',
      passwordUppercase: 'Au moins une lettre majuscule',
    },
  },
};

export default translations;
